<template>
  <div class="resetPassword xi">
    <nh-com></nh-com>
    <div class="startBox">
      <div class="startBoxCenter">
          <div class="" style="display: flex;justify-content: space-between;align-items: center;" v-if="addUser == 1">
            <div class="banner-wrap">
              <div class=" " style="color: #666666; font-size: 16px"><router-link to="/index">首页</router-link><i class="el-icon-arrow-right"></i><a>辨证论治</a><i class="el-icon-arrow-right"></i><a style="color: #666666">选择测试对象</a></div>
            </div>
            <div style="color: #E07712;cursor: pointer;" @click="goback"><img src="../../assets/img/queImg/pcdx_back.png" alt="" style="margin-right: 5px;" srcset="" >返回上一步</div>
          </div>
          <div class="" style="display: flex;justify-content: space-between;align-items: center;" v-if="addUser == 2">
            <div class="banner-wrap">
              <div class=" " style="color: #333333; font-size: 16px;font-weight: bold;"><span>未完成列表({{ AnswerStagingList.length }})</span> <span style="color: #666666;font-weight: 400;margin-left: 15px;"><i class="el-icon-warning-outline"></i> 最多存储10条未完成记录</span></div>
            </div>
            <div style="color: #E07712;cursor: pointer;"  @click="goback1"><img src="../../assets/img/queImg/pcdx_back.png" alt="" style="margin-right: 5px;" srcset="">返回上一步</div>
          </div>
        <div style="display: flex;align-items: center;justify-content: space-between;" v-if="!isStartTest && addUser == 1">
          <div @click="addUserDetail" style="width: 350px;height: 100px;background: linear-gradient(180deg, #FAF2ED, #FFFFFF);margin-top: 19px;text-align: center;line-height: 100px;display: flex;align-items: center;justify-content: space-between;padding: 0 20px;cursor: pointer;">
            <div class="flex-start">
              <img src="../../assets/img/queImg/pcdxxz.png" style="width: 34px;height: 30px;" alt="" srcset="">
              <span style="font-weight: bold;font-size: 18px;color: #333333;margin-left: 10px;">新增测试对象</span>
            </div>
            <img src="../../assets/img/queImg/pcdxadd.png" alt="" srcset="">
          </div>
          <div @click="goAnswerStaging()" style="width: 350px;height: 100px;background: linear-gradient(180deg, #FAF2ED, #FFFFFF);margin-top: 19px;text-align: center;line-height: 100px;display: flex;align-items: center;justify-content: space-between;padding: 0 20px;cursor: pointer;">
            <div class="flex-start">
              <img src="../../assets/img/queImg/pcdxwwc.png" style="width: 34px;height: 30px;" alt="" srcset="">
              <span style="font-weight: bold;font-size: 18px;color: #333333;margin-left: 10px;">未完成测试列表</span>
            </div>
            <span v-if="AnswerStagingList.length > 0" style="font-weight: bold;font-size: 18px;color: #333333;">({{ AnswerStagingList.length }})</span>
          </div>
        </div>
      <template v-if="!isStartTest">
        <!-- 选择测试人 -->
        <div class="" v-if="addUser == 1" style="width: 100%">
          <div  style="margin: 20px 0;position: relative;">
            <el-input class="searchInput" v-model="keyWord" placeholder="搜索测试对象..."  @keyup.enter.native="search"> <i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
            <span style="position: absolute;top: 10px;right: 30px;font-size: 16px;color: #333333;cursor: pointer;" @click="search">搜索</span>
          </div>
          <div class="selectUser-div">
            <div class="">
              <div class="userList-div flex-wrap">
                <div class="item-div flex-center-columns" v-for="(item, index) in answerUserList" :key="index" :class="{ active: selectAnswerUser.id == item.id }" @click="selectAnswerUser = item">
                  <div class="userName oneLines">{{ item.answerUserName }} <span class="sexBox">{{ item.answerSex ? "女" : "男" }}</span></div>
                  <div class="userInfo"> {{ item.answerAgeDesc }} {{ item.answerPhoneDesc }}</div>
                  <!-- <div class="userInfo">基础病：{{ item.diseaseName ? item.diseaseName : '--' }}</div> -->
                  <div class="topDel-div">
                    <i class="el-icon-edit" @click="editAnswerUser(item)" style="margin-right: 15px">编辑</i>
                    <i class="el-icon-delete" @click="delAnswerUser(item, index)">删除</i>
                  </div>
                </div>
                <div v-if="answerUserList.length == 0" style="display: flex;justify-content: center;flex-direction: column;margin: auto;margin-top: 100px;">
                  <img src="../../assets/img/queImg/defaultpage.png" alt="" srcset="">
                  <!-- <span style="text-align: center;margin-top: 10px;">暂无测试对象</span> -->
                    <span v-if="keyWord == ''" style="text-align: center;margin-top: 10px;">暂无测试对象</span>
                    <span v-if="keyWord != ''" style="text-align: center;margin-top: 10px;">未搜索到该测试对象</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="" v-if="addUser == 2" style="width: 100%;margin-top: 20px;">
          <div class="selectUser-div1" style="position: relative;">
            <div class="selectUser-box">
                <div class="item-div1" v-for="(item, index) in AnswerStagingList" :key="index">
                  <div class="flex-s-b">
                    <div class="" style="display: flex; align-items: center">
                      <div style="margin-right: 10px" class="userNameBox">{{ item.answerUserInfo.answerUserName }}</div>
                      <div class="userInfo">{{ item.answerUserInfo.answerSex ? "女" : "男" }}<span style="margin: 0 10px;">{{ item.answerUserInfo.ageContent }}</span>{{ item.answerUserInfo.showanswerPhone }}</div>
                    </div>
                    <div class="titleBoxTextimage" @click.stop="goChooseCheck(item)">
                      <img :src="item.checked ? urlCheckM : noUrlCheckM" />
                    </div>
                  </div>
                  <!-- <div class="userNameBox1" style="color: #00c4ac; margin-left: 35px">主症:{{ item.answerName }}</div> -->
                    <div class="flex-s-b" style="margin-top: 15px;">
                      <div class="flex-s-b-r">
                        <div class="" style="display: flex; align-items: center">
                          <div class="userNameBox1" style="color: #DA7F1D"><span style="margin-right: 10px;">答题进度</span>{{ item.questionIndex }}</div>
                          <div class="userNameBox1">{{ "/" + item.questionTotal }}题</div>
                          <div class="userInfo"  style="margin-left: 60px;font-size: 14px;">{{ item.answerDate | timefilters }}</div>
                        </div>
                        <el-progress :percentage="item.percentnum" color="#F7B670"></el-progress>
                      </div>
                      <div style="display: flex; align-items: center">
                        <div class="delBox1" @click.stop="godelBox(item)">
                          删除
                        </div>
                        <div class="delBox" @click.stop="gostartBox(item)">继续测试 ></div>
                      </div>
                    </div>
                </div>
                <div v-if="answerUserList.length == 0" style="display: flex;justify-content: center;flex-direction: column;margin: auto;margin-top: 100px;">
                  <img src="../../assets/img/queImg/defaultpage.png" alt="" srcset="">
                  <span style="text-align: center;margin-top: 10px;">暂无测试对象</span>
                </div>
    
          </div>
                      <div class="zsureBtn flex-s-b">
                  <div style="display: flex; align-items: center" @click="allSelect">
                    <div class="titleBoxTextimage" style="margin-right: 10px;">
                      <img :src="cssbtn ? urlCheckM : noUrlCheckM" />
                    </div>
                    <span>全选</span>
                  </div>
                  <div class="delBox" @click.stop="goalldelBox" style="margin-left: 40px">删除</div>
                </div>
        </div>
      </div>
      </template>
      <div class="" v-if="isStartTest">
        <div class="drugTitle">
            <div @click="goSearch" class="zdrugInputclass"><span><i class=" el-icon-search" style="margin-right: 20px;"></i>请输入症状名...</span> <span>搜索</span></div>
        </div>
        <div class="startBoxleft">
          <div class="" v-if="categoryList.length > 0">
            <div class="" style="font-size: 16px; font-weight: bold;margin-bottom: 10px;"><img src="../../assets/img/queImg/pcsparkles.png" style="width: 16px ;height: 16px;" alt="" srcset="">症状分类</div>
            <div class="" style="display: flex; flex-wrap: wrap;gap: 13px;">
              <div class="wrapDiv" v-for="(item, index) in categoryList" :key="index">
                <div :class="categoryindex == index ? 'goodTagCheck' : 'goodTag'" @click="gotext(item, index)">
                  {{ item.categoryName }}
                </div>
              </div>
            </div>
          </div>
          <div class="" style="margin-top: 15px" v-if="categoryList1.length > 0">
            <div class="" style="font-size: 16px; font-weight: bold;margin-bottom: 10px;"><img src="../../assets/img/queImg/pcsparkles.png" style="width: 16px ;height: 16px;" alt="" srcset="">症状分类</div>
            <div class="" style="display: flex; flex-wrap: wrap;gap: 13px;">
              <div class="wrapDiv" v-for="(item, index) in categoryList1" :key="index">
                <div :class="categoryindex1 == index ? 'goodTagCheck' : 'goodTag'" @click="gotext1(item, index)">
                  {{ item.categoryName }}
                </div>
              </div>
            </div>
          </div>
          <div class="" style="margin-top: 15px" v-if="categoryList2.length > 0">
            <div class="" style="font-size: 16px; font-weight: bold;margin-bottom: 10px;"><img src="../../assets/img/queImg/pcsparkles.png" style="width: 16px ;height: 16px;" alt="" srcset="">症状分类</div>
            <div class="" style="display: flex; flex-wrap: wrap;gap: 13px;">
              <div class="wrapDiv" v-for="(item, index) in categoryList2" :key="index">
                <div :class="categoryindex2 == index ? 'goodTagCheck' : 'goodTag'" @click="gotext2(item, index)">
                  {{ item.categoryName }}
                </div>
              </div>
            </div>
          </div>
          <!-- 主症列表 -->
          <div v-if="DiagnosiscategoryList.length > 0" class="" style="margin-top: 15px">
            <div class="" style="font-size: 16px; font-weight: bold;margin-bottom: 10px;"><img src="../../assets/img/queImg/pcsparkles.png" style="width: 16px ;height: 16px;" alt="" srcset="">症状分类</div>
            <div class="" style="display: flex; flex-wrap: wrap;gap: 13px;">
              <div class="wrapDiv" v-for="(item, index) in DiagnosiscategoryList" :key="index" >
                <div :class="Diagnosiscategoryindex == index ? 'goodTagCheck' : 'goodTag'" @click="gotextDiagnosis(item, index)">
                  {{ item.primarySymptomName }}
                </div>
              </div>
              <div class="wrapDiv">
                <div v-if="pageIndex < pageCount" class="goodTag" @click="gotextDiagnosiMore">更多...</div>
              </div>
            </div>
          </div>
          <el-dialog title="详情" :visible.sync="dialogVisibleDetail" width="50%">
            <div class="dialogTitle">
              {{ selfDiagnosisPrimarySymptomDetail.primarySymptomName }}
            </div>
            <div class="textdetail" v-if="selfDiagnosisPrimarySymptomDetail.symptomDescription">
              <div class="" @click="handleRichClick">
                <p  v-html="richHtml"></p>
              </div>
            </div>
             <div class="startBtn2" @click="goStartSure"><span class="text">确定选择</span></div>
          </el-dialog>
        <el-dialog
            title="图片预览"
            :visible.sync="dialogVisible"
           width="50%"
            append-to-body
            center
          >
            <div style="text-align:center;">
              <img :src="previewImgSrc" style="max-width:100%;max-height:100%;" />
            </div>
          </el-dialog>
        </div>
      </div>
    </div>

    </div>
    <div v-if="!isStartTest  && addUser == 1" class="startBtn" @click="goStart">开始测试</div>
    <!-- 症状弹窗 -->
    <el-dialog title="提示" :visible.sync="centerDialogVisible" width="50%" center>
      <div class="" style="text-align: right; padding-right: 30px; margin-top: 30px">
        <el-button round type="warning" @click="goStartSure">确定</el-button>
      </div>
    </el-dialog>
    <!-- 搜索 -->
    <el-dialog title="提示" :visible.sync="searchDialogVisible" width="50%" center>
      <div class="" style="margin-top: 10px">
        <!-- 主症列表 -->
        <div class="" style="margin-top: 15px">
          <div class="" style="font-size: 16px; font-weight: bold">症状分类</div>
          <div class="" style="display: flex; flex-wrap: wrap">
            <div class="" v-for="(item, index) in DiagnosiscategoryList1" :key="index" style="margin-top: 10px">
              <div :class="Diagnosiscategoryindex == index ? 'goodTagCheck' : 'goodTag'" @click="gotextDiagnosis(item, index)">
                {{ item.primarySymptomName }}
              </div>
            </div>
            <div style="margin-top: 10px">
              <div v-if="pageIndex1 < pageCount1" class="goodTag" @click="gotextDiagnosiMore1">更多...</div>
            </div>
          </div>
        </div>
        <div class="textdetail" v-if="selfDiagnosisPrimarySymptomDetail.symptomDescription">
          <div class="el-icon-warning-outline" style="color: #f6a11f; margin-top: 5px"></div>
          <div class="" style="font-size: 14px; color: #666666; margin-left: 5px">
            <p v-html="selfDiagnosisPrimarySymptomDetail.description.replace(/\n/g, '</p> <p>')"></p>
          </div>
        </div>
      </div>
      <div class="" style="text-align: right; padding-right: 30px; margin-top: 30px">
        <el-button round type="warning" @click="goStartSure">确定</el-button>
      </div>
    </el-dialog>
      <el-dialog
      title="新增测试对象"
      :visible.sync="addDialogVisible"
      width="30%"
      center
      >
      <!-- 添加测试人信息 -->
      <div class="addUser-div">
          <div class="top-tip"><i class="el-icon-warning"></i>为方便保存检测结果，建议您准确填写相关信息</div>
          <div class="center-form">
            <el-form ref="answerUser" :model="answerUser" label-width="100px" :rules="rules">
              <el-form-item label="姓名:" prop="answerUserName" style="margin-bottom: 30px;">
                <el-input class="w-18" v-model="answerUser.answerUserName" placeholder="请输入您的姓名"></el-input>
              </el-form-item>
              <el-form-item label="性别:" prop="answerSex" style="margin-bottom: 30px;">
                <el-radio-group v-model="answerUser.answerSex">
                  <el-radio :label="0">男</el-radio>
                  <el-radio :label="1">女</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="年龄:" prop="answerAge" style="margin-bottom: 30px;">
                <!-- <el-radio-group v-model="answerUser.answerAge" class="age-radio">
                  <el-radio :label="0">6岁以下</el-radio>
                  <el-radio :label="1">7-12岁</el-radio>
                  <el-radio :label="2">13-17岁</el-radio>
                  <el-radio :label="3">18-45岁</el-radio>
                  <el-radio :label="4">46-69岁</el-radio>
                  <el-radio :label="5">69岁以上</el-radio>
                </el-radio-group> -->
                <el-select  class="w-18" v-model="answerUser.answerAge" placeholder="请选择您的年龄区间">
                  <el-option
                    v-for="item in options"
                    :key="item.label"
                    :label="item.value"
                    :value="Number(item.label)">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="手机号:" prop="answerPhone" style="margin-bottom: 30px;">
                <el-input class="w-18" v-model="answerUser.answerPhone" placeholder="请输入您的手机号"></el-input>
              </el-form-item>
              <el-form-item label="基础病:" prop="diseaseName" style="margin-bottom: 30px;">
                <el-input class="w-18" v-model="answerUser.diseaseName" placeholder="请输入您的基础病"></el-input>
              </el-form-item>
              <el-form-item>
                <div class="startBtn1" @click="saveBtn('answerUser')"><span class="text">提交</span></div>
              </el-form-item>
            </el-form>
          </div>
      </div>
    </el-dialog>
    <ft-com></ft-com>
  </div>
</template>

<script>
import ftCom from "../../components/footerNew";
import nhCom from "../../components/header";
import { zdrugconsultationMain } from "../../components/zdrugconsultation/zdrugconsultation";
import { Test } from "../../components/company/test";
export default {
  name: "resetPassword",
  components: {
    ftCom,
    nhCom,
  },
  data() {
    var zdrugconsultation = new zdrugconsultationMain(this.TokenClient, this.Services.Disease);
    var test = new Test(this.TokenClient, this.Services.Statics);
    return {
      testDomain: test,
      zdrugconsultationMain: zdrugconsultation,
      nam: "123",
      startShow: true,
      sexShow: false,
      sexName: "",
      sexShowName: "男",
      sexindex: 0,
      ageShow: false,
      ageName: "",
      ageShowName: "",
      ageindex: 1,
      sexList: [{ name: "男" }, { name: "女" }],
      showPrimarySymptomName: "",
      primarySymptomNameText: "",
      opcategoryindex: -1,
      centerDialogVisible: false,
      categoryList: [],
      categoryindex: -1,
      categoryList1: [],
      categoryindex1: -1,
      categoryList2: [],
      categoryindex2: -1,
      DiagnosiscategoryList: [],
      Diagnosiscategoryindex: -1,
      selfDiagnosisPrimarySymptomDetail: {},
      selfId: "",
      questindex: 0,
      questionList: [],
      processList: [],
      recordId: "",
      resultList: {},
      UserSelfDiagnosisRecordList: [],
      http: "",
      imgtextindex: -1,
      optionname: "",
      pageIndex: 1,
      pageCount: 1,
      selfDiagnosisId: "",
      searchDialogVisible: false,
      pageIndex1: 1,
      pageCount1: 1,
      DiagnosiscategoryList1: [],
      dialogVisibleDetail: false,
      selfSex: "",
      selfAge: "",
      quename: "",
      userInfo: this.$store.state.localData.userInfo,
      answerUser: {
        userId: 0,
        userName: "",
        answerUserName: "",
        answerSex: 0,
        answerAge: '',
        answerPhone: "",
        diseaseName: "",
      }, //测试对象
      selectAnswerUser: "", //测试对象
      answerUserList: [], //测试对象list
      addUser: 1,
      rules: {
        answerUserName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        answerPhone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { pattern: /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/, message: "请输入合法手机号/电话号", trigger: "blur" },
        ],
         answerAge: [{ required: true, message: "请选择测试对象年龄区别", trigger: "blur" }],
      },
      isStartTest: false, //是否开始测试
      keyWord: "",
      isAnswerStaging: false,
      AnswerStagingList: [],
      urlCheckM: require("@/assets/img/zdrugConsult/check.png"),
      noUrlCheckM: require("@/assets/img/zdrugConsult/znocheck.png"),
      cssbtn:false,
      // 门诊参数
      mztype:  this.$route.query.type ? this.$route.query.type : '',
      answerUserName:  this.$route.query.answerUserName ? this.$route.query.answerUserName : '',
      answerPhone:  this.$route.query.answerPhone ? this.$route.query.answerPhone : '',
      userListChoose:'',
      addDialogVisible:false,
      options: [{
        value: '6岁以下',
        label: '0'
      }, {
        value: '7-12岁',
        label: '1'
      }, {
        value: '13-17岁',
        label: '2'
      }, {
        value: '18-45岁',
        label: '3'
      }, {
        value: '46-69岁',
        label: '4'
      }, {
        value: '69岁以上',
        label: '5'
      }],
            dialogVisible:false,
      previewImgSrc:''
    };
  },
      computed: {
   richHtml() {
  let html = this.selfDiagnosisPrimarySymptomDetail.description
  // 替换img，增加style，覆盖原width、height
  html = html.replace(/<img([^>]*)>/gi, (match, attr) => {
    return `<img${attr} style="max-width:100%;max-height:420px;width:auto!important;height:auto!important;">`
  })
  return html
}
  },
  mounted() {
    if (this.$route.query.ZStype == '1') {
      this.userListChoose = window.sessionStorage.getItem('chooseUser') ? JSON.parse(window.sessionStorage.getItem('chooseUser')) : ''
      this.isStartTest = true
      this.goStart()
    }
    this.getMyselfAnswerInfo()
    this.http = this.Services.Statics;
    this.userListChoose = window.sessionStorage.getItem('chooseUser') ? JSON.parse(window.sessionStorage.getItem('chooseUser')) : ''
  },
  methods: {
    handleRichClick(e) {
      const target = e.target;
      if (target.tagName.toUpperCase() === "IMG") {
        this.previewImgSrc = target.src;
        this.dialogVisible = true;
      }
    },
        addUserDetail(){
      this.answerUser = {
        userId: 0,
        userName: "",
        answerUserName: "",
        answerSex: 0,
        answerAge: "",
        answerPhone: "",
        diseaseName: "",
      }
      this.addDialogVisible = true
    },
    goback(){
      this.$router.go(-1)
    },
    goback1(){
      this.addUser = 1
    },
    goalldelBox() {
      let params = [];
      for (var i = 0; i < this.AnswerStagingList.length; i++) {
        if (this.AnswerStagingList[i].checked) {
          params.push(this.AnswerStagingList[i].id);
        }
      }
      this.$confirm("确认删除所选记录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.testDomain.deleteAnswerStaging(
            params.toString(),
            res => {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getAnswerStagingInfoData();
            },
            error => {
              console.log("请求失败!请刷新重试:", error);
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    gostartBox(item) {
      this.$router.push({
        path: "/zdrugconsultation/zDrugProgress",
        query: {
          id: this.selfId,
          selectAnswerUser: this.selectAnswerUser,
          age: this.selfAge,
          sex: this.selfSex,
          name: this.quename,
          isgoId: item.id,
        },
      });
    },
    godelBox(e) {
      this.$confirm("确认删除所选记录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.testDomain.deleteAnswerStaging(
            e.id,
            res => {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getAnswerStagingInfoData();
            },
            error => {
              console.log("请求失败!请刷新重试:", error);
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    allSelect() {
      this.cssbtn = !this.cssbtn;
      if (this.cssbtn == true) {
        for (var i = 0; i < this.AnswerStagingList.length; i++) {
          this.AnswerStagingList[i]["checked"] = true;
        }
      } else {
        for (var i = 0; i < this.AnswerStagingList.length; i++) {
          this.AnswerStagingList[i]["checked"] = false;
        }
      }
    },
    goChooseCheck(e) {
      for (let j = 0; j < this.AnswerStagingList.length; j++) {
        if (e.id == this.AnswerStagingList[j].id) {
          this.AnswerStagingList[j].checked = !this.AnswerStagingList[j].checked;
          // this.$set(this.AnswerStagingList[j], 'checked' , !this.AnswerStagingList[j].checked, )
        }
      }
      const allcartList = this.AnswerStagingList.every(item => {
        return item.checked == true;
      });
      if (allcartList) {
        this.cssbtn = true;
      } else {
        this.cssbtn = false;
      }
    },
    goAnswerStaging() {
      if (this.AnswerStagingList.length == 0) {
        this.$message({
          message: "暂无未完成数据",
          type: "warning",
        });
        return;
      }
      this.addUser = 2;
      this.getAnswerStagingInfoData();
    },
    search() {
      this.getMyselfAnswerInfo();
    },
    /**
     * 获取测试用户
     */
    getMyselfAnswerInfo() {
      this.testDomain.MyselfAnswerInfo(
        this.keyWord,
        res => {
          this.getAnswerStagingInfoData();
          this.answerUserList = [];
          this.selectAnswerUser = {};
          this.answerUserList = res.data;
          this.answerUserList.forEach((item,index) => {
            if (item.answerAge == 0) {
              item.answerAgeDesc = "6岁以下";
            } else if (item.answerAge == 1) {
              item.answerAgeDesc = "7-12岁";
            } else if (item.answerAge == 2) {
              item.answerAgeDesc = "13-17岁";
            } else if (item.answerAge == 3) {
              item.answerAgeDesc = "18-45岁";
            } else if (item.answerAge == 4) {
              item.answerAgeDesc = "46-69岁";
            } else {
              item.answerAgeDesc = "69岁以上";
            }
            item.answerPhoneDesc = item.answerPhone.substr(0, 3) + "****" + item.answerPhone.substr(7);
            if (this.userListChoose.type == 'menzhen') { 
              if (item.answerUserName == this.userListChoose.answerUserName && item.answerPhone == this.userListChoose.answerPhone && item.answerSex == this.userListChoose.answerSex && item.answerAge == this.userListChoose.answerAge && item.diseaseName == this.userListChoose.diseaseName) {
                this.selectAnswerUser = this.answerUserList[index]
              }
            } else {
              this.selectAnswerUser = this.answerUserList[0];
            }
          });
     
        },
        error => {
          console.log("请求失败!请刷新重试:", error);
        }
      );
    },
    getAnswerStagingInfoData() {
      this.testDomain.getAnswerStaging(
        "z0",
        res => {
          this.AnswerStagingList = res.data;
          for (let i = 0; i < this.AnswerStagingList.length; i++) {
            this.AnswerStagingList[i].answerUserInfo.showanswerPhone = this.AnswerStagingList[i].answerUserInfo.answerPhone.substr(0, 3) + "****" + this.AnswerStagingList[i].answerUserInfo.answerPhone.substr(7);
            if (this.AnswerStagingList[i].answerUserInfo.answerAge == 0) {
              this.AnswerStagingList[i].answerUserInfo["ageContent"] = "6岁以下";
            } else if (this.AnswerStagingList[i].answerUserInfo.answerAge == 1) {
              this.AnswerStagingList[i].answerUserInfo["ageContent"] = "7-12岁";
            } else if (this.AnswerStagingList[i].answerUserInfo.answerAge == 2) {
              this.AnswerStagingList[i].answerUserInfo["ageContent"] = "13-17岁";
            } else if (this.AnswerStagingList[i].answerUserInfo.answerAge == 3) {
              this.AnswerStagingList[i].answerUserInfo["ageContent"] = "18-45岁";
            } else if (this.AnswerStagingList[i].answerUserInfo.answerAge == 4) {
              this.AnswerStagingList[i].answerUserInfo["ageContent"] = "46-69岁";
            } else {
              this.AnswerStagingList[i].answerUserInfo["ageContent"] = "69岁以上";
            }
            this.AnswerStagingList[i]["percentnum"] = (100 / this.AnswerStagingList[i].questionTotal) * this.AnswerStagingList[i].questionIndex;
            // this.AnswerStagingList[i]['checked'] = false
            this.$set(this.AnswerStagingList[i], "checked", false);
          }
        },
        error => {
          this.AnswerStagingList = [];
        }
      );
    },
    /**
     * 添加测试用户
     */
    saveBtn(formName) {
      this.$refs[formName].validate(val => {
        if (val) {
          if (this.answerUser.id) {
            this.testDomain.EditAnswerUser(
              this.answerUser,
              res => {
                this.$message({
                  type: "success",
                  message: "修改成功!",
                });
                this.addDialogVisible = false
                this.answerUser = {
                  userId: 0,
                  userName: "",
                  answerUserName: "",
                  answerSex: 0,
                  answerAge: '',
                  answerPhone: "",
                  diseaseName: "",
                },
                  this.getMyselfAnswerInfo();
              },
              error => {
                console.log("请求失败!请刷新重试:", error);
              }
            );
          } else {
            this.answerUser.userId = this.userInfo.id;
            this.answerUser.userName = this.userInfo.userName;
            this.testDomain.AddAnswerUser(
              this.answerUser,
              res => {
                this.$message({
                  type: "success",
                  message: "添加成功!",
                });
                 this.addDialogVisible = false
                this.answerUser = {
                  userId: 0,
                  userName: "",
                  answerUserName: "",
                  answerSex: 0,
                  answerAge: '',
                  answerPhone: "",
                  diseaseName: "",
                },
                  this.getMyselfAnswerInfo();
              },
              error => {
                console.log("请求失败!请刷新重试:", error);
              }
            );
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /**
     * 删除测试用户
     * @param {*} item
     * @param {*} i
     */
    delAnswerUser(item, i) {
        this.$confirm('确认删除当前测试对象吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            this.testDomain.RemoveAnswerUser(
              item.id,
              res => {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.answerUserList.splice(i, 1);
                this.selectAnswerUser = {};
                if (this.answerUserList.length == 0) {
                  this.selectAnswerUser = "";
                }
              },
              error => {
                console.log("请求失败!请刷新重试:", error);
              }
            );
        }).catch(() => {
               
        });
    },
    editAnswerUser(item) {
           this.addDialogVisible =true
      this.answerUser.id = item.id;
      this.answerUser.userId = item.userId;
      this.answerUser.userName = item.userName;
      this.answerUser.answerUserName = item.answerUserName;
      this.answerUser.answerSex = item.answerSex ? 1 : 0;
      this.answerUser.answerAge = Number(item.answerAge);
      this.answerUser.answerPhone = item.answerPhone;
      this.answerUser.diseaseName = item.diseaseName;
    },
    goSearch() {
      this.$router.push({
        path: "/zdrugconsultation/zDrugSearch",
        query: {
          selectAnswerUser: this.selectAnswerUser,
        },
      });
      if (localStorage.getItem('selectAnswerUser2')) {
         localStorage.removeItem("selectAnswerUser2")
      }
      localStorage.setItem('selectAnswerUser2', JSON.stringify(this.selectAnswerUser));
    },
    gosearchCategory() {
      this.centerDialogVisible = false;
      this.DiagnosiscategoryList1 = [];
      this.searchDialogVisible = true;
      this.getSelfDiagnosisPrimarySymptomList1();
    },
    // 主症列表
    getSelfDiagnosisPrimarySymptomList1() {
      var _this = this;
      _this.pageIndex1 = 1;
      _this.zdrugconsultationMain.getSelfDiagnosisPrimarySymptom(
        0,
        "%20",
        this.selectAnswerUser.answerSex,
        this.selectAnswerUser.answerAge,
        _this.pageIndex1,
        function (data) {
          _this.DiagnosiscategoryList1 = data.data.results;
          _this.pageCount1 = data.data.pageCount;
        },
        function (error) {
          if (error.statusCode == 404) {
            _this.DiagnosiscategoryList = [];
          }
        }
      );
    },
    gotextDiagnosiMore1() {
      var _this = this;
      _this.pageIndex1 = _this.pageIndex1 + 1;
      _this.zdrugconsultationMain.getSelfDiagnosisPrimarySymptom(
        0,
        "%20",
        this.selectAnswerUser.answerSex,
        this.selectAnswerUser.answerAge,
        _this.pageIndex1,
        function (data) {
          _this.DiagnosiscategoryList1 = _this.DiagnosiscategoryList1.concat(data.data.results);
          _this.pageCount1 = data.data.pageCount;
        },
        function (error) {
          console.log(error);
          if (error.statusCode == 404) {
            _this.DiagnosiscategoryList1 = [];
          }
        }
      );
    },
    gotextDiagnosiMore() {
      var _this = this;
      _this.pageIndex = _this.pageIndex + 1;
      _this.zdrugconsultationMain.getSelfDiagnosisPrimarySymptom(
        _this.selfDiagnosisId,
        "%20",
        this.selectAnswerUser.answerSex,
        this.selectAnswerUser.answerAge,
        _this.pageIndex,
        function (data) {
          _this.DiagnosiscategoryList = _this.DiagnosiscategoryList.concat(data.data.results);
          _this.pageCount = data.data.pageCount;
        },
        function (error) {
          console.log(error);
          if (error.statusCode == 404) {
            _this.DiagnosiscategoryList = [];
          }
        }
      );
    },
    goUserSelf(e) {
      this.$router.push({
        path: "/zdrugconsultation/zdrugDetail",
        query: {
          id: e.id,
        },
      });
    },
    // 症状分类
    goStart() {
      var _this = this;
        if(_this.selectAnswerUser.answerAge == null && _this.userListChoose.answerAge == null) {
        _this.$confirm('您还未选择测试对象，请先选中后再开始测试。', '提示', {
          confirmButtonText: '我知道了',
          showCancelButton:false,
          type: 'warning'
        }).then(() => {
    
        }).catch(() => {
               
        });
        return
      }
      if(_this.answerUserList.length == 0 && _this.userListChoose.type != 'menzhen') {
        _this.$confirm('您还未选择测试对象，请先选中后再开始测试。', '提示', {
          confirmButtonText: '我知道了',
          showCancelButton:false,
          type: 'warning'
        }).then(() => {
    
        }).catch(() => {
               
        });
        return
      }
      this.isStartTest = true;
      _this.zdrugconsultationMain.getSelfDiagnosisCategory(
        "",
        function (data) {
          _this.categoryList = data.data;
        },
        function (error) {
          console.log(error);
          if (error.statusCode == 404) {
            _this.categoryList = [];
          }
        }
      );
    },
    gotext(item, index) {
      this.categoryList1 = [];
      this.categoryindex1 = -1;
      this.categoryList2 = [];
      this.categoryindex2 = -1;
      this.DiagnosiscategoryList = [];
      this.Diagnosiscategoryindex = -1;
      this.selfDiagnosisPrimarySymptomDetail = {};
      this.categoryindex = index;
      if (item.isEnableChildren) {
        this.getSelfDiagnosisCategoryList1(item.categoryId);
      } else {
        this.getSelfDiagnosisPrimarySymptomList(item.categoryId);
      }
    },
    gotext1(item, index) {
      this.categoryList2 = [];
      this.categoryindex2 = -1;
      this.DiagnosiscategoryList = [];
      this.Diagnosiscategoryindex = -1;
      this.selfDiagnosisPrimarySymptomDetail = {};
      this.categoryindex1 = index;
      if (item.isEnableChildren) {
        this.getSelfDiagnosisCategoryList2(item.categoryId);
      } else {
        this.getSelfDiagnosisPrimarySymptomList(item.categoryId);
      }
    },
    gotext2(item, index) {
      this.DiagnosiscategoryList = [];
      this.Diagnosiscategoryindex = -1;
      this.selfDiagnosisPrimarySymptomDetail = {};
      this.categoryindex2 = index;
      if (item.isEnableChildren) {
        this.getSelfDiagnosisCategoryList3(item.categoryId);
      } else {
        this.getSelfDiagnosisPrimarySymptomList(item.categoryId);
      }
    },
    // 症状分类
    getSelfDiagnosisCategoryList1(e) {
      var _this = this;

      _this.zdrugconsultationMain.getSelfDiagnosisCategory(
        e,
        function (data) {
          _this.categoryList1 = data.data;
        },
        function (error) {
          if (error.statusCode == 404) {
            _this.categoryList1 = [];
          }
        }
      );
    },
    getSelfDiagnosisCategoryList2(e) {
      var _this = this;
      _this.zdrugconsultationMain.getSelfDiagnosisCategory(
        e,
        function (data) {
          _this.categoryList2 = data.data;
        },
        function (error) {
          console.log(error);
          if (error.statusCode == 404) {
            _this.categoryList2 = [];
          }
        }
      );
    },
    gotextopMultiple(e) {
      e.checked = !e.checked;
      this.optionname = e;
    },
    // 主症列表
    getSelfDiagnosisPrimarySymptomList(e) {
      var _this = this;
      _this.selfDiagnosisId = e;
      _this.pageIndex = 1;
      _this.zdrugconsultationMain.getSelfDiagnosisPrimarySymptom(
        e,
        "%20",
        this.selectAnswerUser.answerSex,
        this.selectAnswerUser.answerAge,
        _this.pageIndex,
        function (data) {
          _this.DiagnosiscategoryList = data.data.results;
          _this.pageCount = data.data.pageCount;
        },
        function (error) {
          console.log(error);
          if (error.statusCode == 404) {
            _this.DiagnosiscategoryList = [];
          }
        }
      );
    },
    // 主症详情
    getSelfDiagnosisPrimarySymptomDetailList(e) {
      var _this = this;
      _this.zdrugconsultationMain.getSelfDiagnosisPrimarySymptomDetail(
        e,
        function (data) {
          _this.selfDiagnosisPrimarySymptomDetail = data.data;
          _this.selfSex = data.data.filterSex;
          _this.selfAge = data.data.minAge;
          _this.quename = data.data.primarySymptomName;
          _this.dialogVisibleDetail = true;
        },
        function (error) {
          console.log(error);
        }
      );
    },
    // 滚动到底部
    handleScrollBottom() {
      this.$nextTick(() => {
        let scrollElem = this.$refs.scrollDiv;
        scrollElem.scrollTo({ top: scrollElem.scrollHeight, behavior: "smooth" });
      });
    },
    goStartSure() {
      this.dialogVisibleDetail = false;
      this.$router.push({
        path: "/zdrugconsultation/zDrugProgress",
        query: {
          id: this.selfId,
          selectAnswerUser: this.selectAnswerUser,
          age: this.selfAge,
          sex: this.selfSex,
          name: this.quename,
        },
      });
    },
    // 题库
    getSelfDiagnosisQuestionList() {
      var _this = this;
      let isGender = false;
      if (_this.sexShowName == "男") {
        isGender = true;
      } else {
        isGender = false;
      }
      _this.zdrugconsultationMain.getSelfDiagnosisQuestion(
        _this.selfId,
        isGender,
        _this.ageShowName,
        function (data) {
          for (let i = 0; i < data.data.length; i++) {
            data.data[i].arryIndex = 0;
            if (data.data[i].fileUrl) {
              data.data[i].fileUrl = JSON.parse(data.data[i].fileUrl);
            }
            for (let j = 0; j < data.data[i].selfDiagnosisQuestionOption.length; j++) {
              if (data.data[i].selfDiagnosisQuestionOption[j].fileUrl && data.data[i].selfDiagnosisQuestionOption[j].fileUrl != "null") {
                data.data[i].selfDiagnosisQuestionOption[j].fileUrl = JSON.parse(data.data[i].selfDiagnosisQuestionOption[j].fileUrl);
                data.data[i].imgTrue = true;
              }
              if (data.data[i].type == "Multiple") {
                data.data[i].selfDiagnosisQuestionOption[j].checked = false;
              }
            }
          }
          _this.questionList = data.data;
          _this.processList.push(_this.questionList[_this.questindex]);
          _this.handleScrollBottom();
        },
        function (error) {
          console.log(error);
        }
      );
    },
    gotextDiagnosis(item, index) {
      this.Diagnosiscategoryindex = index;
      this.showPrimarySymptomName = item.primarySymptomName;
      this.getSelfDiagnosisPrimarySymptomDetailList(item.id);
      this.selfId = item.id;
    },
    goresult() {
      this.centerDialogVisible = true;
    },
    gotexsex(e, index) {
      this.sexShowName = e.name;
      this.sexindex = index;
    },
    gosexSure() {
      this.sexName = this.sexShowName;
      this.sexShow = false;
      this.ageShow = true;
    },
    goAgeSure() {
      this.ageName = this.ageShowName;
      this.ageShow = false;
      this.getSelfDiagnosisQuestionList();
    },
    handleChangeAge(value) {
      this.ageShowName = value;
    },
    gotextop(e, index) {
      this.opcategoryindex = index;
      this.optionname = e;
    },
    gorightresult() {
      var _this = this;
      let params = [];
      let params1 = [];
      for (let i = 0; i < _this.processList.length; i++) {
        if (_this.processList[i].questionOptionList.length > 0) {
          for (let j = 0; j < _this.processList[i].questionOptionList.length; j++) {
            params1.push({
              questionName: _this.processList[i].description,
              questionFileUrl: JSON.stringify(_this.processList[i].fileUrl),
              questionOptionName: _this.processList[i].questionOptionList[j].description,
              questionOptionFileUrl: JSON.stringify(_this.processList[i].questionOptionList[j].fileUrl),
              symptom: _this.processList[i].questionOptionList.relationSymptoms,
              rank: _this.processList[i].rank,
            });
          }
        } else {
          params.push({
            questionName: _this.processList[i].description,
            questionFileUrl: JSON.stringify(_this.processList[i].fileUrl),
            questionOptionName: _this.processList[i].questionOptionList.description,
            questionOptionFileUrl: JSON.stringify(_this.processList[i].questionOptionList.fileUrl),
            symptom: _this.processList[i].questionOptionList.relationSymptoms,
            rank: _this.processList[i].rank,
          });
        }
      }
      let isGender = false;
      if (_this.sexName == "男") {
        isGender = true;
      } else {
        isGender = false;
      }
      let resultParams = {};
      resultParams.primarySymptomId = _this.selfId;
      resultParams.age = _this.ageName;
      resultParams.gender = isGender;
      resultParams.answerDiseaseName = this.selectAnswerUser.diseaseName;
      resultParams.recordInfo = params.concat(params1);
      _this.zdrugconsultationMain.getSelfDiagnosisQuestionSubmit(
        resultParams,
        function (data) {
          _this.zdrugconsultationMain.getUserSelfDiagnosisRecordResult(
            data.data.recordId,
            function (data) {
              _this.resultList = data.data;
              _this.resultList.diagnosisTime = _this.resultList.diagnosisTime.slice(0, 10);
              let contantList = [];
              for (let i = 0; i < _this.resultList.recordResults.length; i++) {
                contantList = _this.resultList.recordResults[i].pulseSymptoms.concat(_this.resultList.recordResults[i].symptoms.concat(_this.resultList.recordResults[i].tongueSymptoms));
                _this.resultList.recordResults[i].contantLists = contantList;
                let newsyndromeSymptoms1 = [];
                for (let k = 0; k < _this.resultList.recordResults[i].syndromeSymptoms.length; k++) {
                  newsyndromeSymptoms1.push({
                    name: _this.resultList.recordResults[i].syndromeSymptoms[k],
                    checked: false,
                  });
                }
                _this.resultList.recordResults[i].newsyndromeSymptoms = newsyndromeSymptoms1;
              }
              for (let m = 0; m < _this.resultList.recordResults.length; m++) {
                for (let n = 0; n < _this.resultList.recordResults[m].contantLists.length; n++) {
                  for (let j = 0; j < _this.resultList.recordResults[m].newsyndromeSymptoms.length; j++) {
                    if (_this.resultList.recordResults[m].newsyndromeSymptoms[j].name == _this.resultList.recordResults[m].contantLists[n]) {
                      _this.resultList.recordResults[m].newsyndromeSymptoms[j].checked = true;
                    }
                  }
                }
              }
            },
            function (error) {
              _this.resultList = data.data;
              console.log(error);
            }
          );
        },
        function (error) {
          console.log(error);
        }
      );
    },
    chooseAnswer(e) {
      if (this.optionname == "") {
        this.$message.error("您尚未选择内容");
        return;
      }
      this.processList[this.processList.length - 1].questionOptionList = this.optionname;
      this.opcategoryindex = -1;
      this.imgtextindex = -1;
      if (this.questindex < this.questionList.length - 1) {
        this.questindex++;
        this.processList.push(this.questionList[this.questindex]);
        this.optionname = "";
      } else {
        this.questindex = this.questionList.length;
        this.gorightresult();
      }
      this.handleScrollBottom();
    },
    chooseAnswerMultiple() {
      if (this.optionname == "") {
        this.$message.error("您尚未选择内容");
        return;
      }
      let optionnameList = [];

      for (let i = 0; i < this.processList[this.processList.length - 1].selfDiagnosisQuestionOption.length; i++) {
        if (this.processList[this.processList.length - 1].selfDiagnosisQuestionOption[i].checked) {
          optionnameList.push(this.processList[this.processList.length - 1].selfDiagnosisQuestionOption[i]);
        }
      }
      this.processList[this.processList.length - 1].questionOptionList = optionnameList;
      console.log(this.processList[this.processList.length - 1].questionOptionList);
      this.opcategoryindex = -1;
      this.imgtextindex = -1;
      this.optionname = "";
      if (this.questindex < this.questionList.length - 1) {
        this.questindex++;
        this.processList.push(this.questionList[this.questindex]);
      } else {
        this.questindex = this.questionList.length;
        this.gorightresult();
      }
      this.handleScrollBottom();
    },
    godetail(e) {
      this.$router.push({
        path: "/zdrugconsultation/zdrugsynDetail",
        query: {
          id: e.syndromeId,
        },
      });
    },

    godetail1() {
      this.$router.push({
        path: "/personal/SelfTest",
        query: {
          type: "2",
        },
      });
    },
    agreeChange(e) {
      this.optionname = e;
    },
    gosearchimgMultiple(e) {
      console.log(e);
      e.checked = !e.checked;
      this.optionname = e;
    },
    gosearchimg(e, index) {
      this.imgtextindex = index;
      this.optionname = e;
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/footer.css";
::v-deep .el-progress__text {
  display: none;
}
.titleBoxTextimage {
  width: 14px;
  height: 14px;
}
.titleBoxTextimage img {
  width: 100%;
  height: 100%;
  display:block;
}
.flex-s-b {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.flex-s-b-r {
  display: flex;
  flex-direction: column;
  width: 60%;
}
.delBox1 {
  width: 80px;
  /* height: 30px; */
  font-size: 14px;
  background: rgba(255,255,255,0);
  border-radius: 4px;
  border: 1px solid #CCCCCC;
  font-size: 14px;
  color: #666666;
  text-align: center;
  padding: 5px 0;
}
.delBox {
  width: 100px;
  /* height: 30px; */
  font-size: 14px;
  color: #ffffff;
  background: linear-gradient(270deg, #EEAB66, #EFC279);
  border-radius: 4px;
  text-align: center;
  padding: 5px 0;
  margin-left: 10px;
}
.userNameBox1 {
  font-size: 14px;
  color: #666666;
}
.userNameBox {
    max-width: 120px;
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*不换行*/
  text-overflow: ellipsis; /*超出部分文字以...显示*/
  text-align: center;
  font-weight: bold;
  font-size: 18px;
  color: #333333;
}
.banner-wrap {
  /* position: relative;
  height: 100%;
  margin: 0 auto; */
}
.leftbox {
  display: flex;
  align-items: center;
}
.leftMessage {
  max-width: 240px;
  margin-top: 15px;
  font-size: 14px;
  padding: 15px;
  background-color: #f4f4f4;
  border-radius: 0px 15px 15px 15px;
  margin-left: 10px;
}
.resultMessage {
  width: 100%;
  margin-top: 15px;
  padding: 15px;
  margin-left: 10px;
  border: 1px solid #f2f2f2;
  box-shadow: 0px 5px 10px 0px rgba(153, 153, 153, 0.16);
  border-radius: 16px;
}
.rightbox {
  display: flex;
  justify-content: flex-end;
  text-align: right;
}
.rightMessage {
  max-width: 240px;
  margin-top: 15px;
  font-size: 14px;
  padding: 15px;
  background-color: #ee9e51;
  border-radius: 15px 0px 15px 15px;
  color: #fff;
}
.startBox {
  background: linear-gradient(180deg, #FFEFDE 0%, #F5F5F5 50%);
  /* border-radius: 19px; */
  padding: 30px;
  /* width: 1200px;
  margin: 30px auto;
  padding: 40px;
  box-shadow: 0px 6px 10px 0px rgba(204, 204, 204, 0.18);
  border-radius: 30px; */
  /* display: flex;
  align-items: center;
  justify-content: space-between; */
}
.startBoxCenter {
  width: 800px;
  margin: auto;
}
.addUser-div {
  /* background: linear-gradient(180deg, #FBF0EA, #FFFFFF 20%); */
  border-radius: 40px;
  padding: 0px 10px;
  width: 500px;
  margin: auto;
  padding-bottom: 70px;
}

/* .startBox .addUser-div .addUser-box {
  background: #fff;
  width: 90%;
  margin: 0 auto;
  height: 100%;
  border-radius: 40px;
} */

.addUser-div .top-tip {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #F15C1A;
  margin-bottom: 20px;
  text-align: center;
}

.addUser-div .center-form {
  width: 100%;
}

.addUser-div .center-form /deep/ .el-form {
  width: 100%;
  margin: 0 auto;
}

.addUser-div .center-form /deep/ .el-form-item__label {
  /* color: #01c2ac; */
  font-weight: 400;
  font-size: 15px;
}

.addUser-div .center-form .age-radio /deep/ .el-radio {
  line-height: 40px;
  color: #cf7f31;
}
.addUser-div .center-form /deep/ .el-radio .el-radio__input.is-checked .el-radio__inner {
  border-color: #F15C1A;
    background: #F15C1A;
}
.addUser-div .center-form /deep/ .el-radio__input.is-checked+.el-radio__label  {
  color: #F15C1A;
}

.addUser-div .center-form .age-radio {
  width: 80%;
}
.addUser-div .btn,
.selectUser-div .btn {
  width: 160px;
  height: 50px;
  background: linear-gradient(90deg, #03cdb4, #00a28e);
  box-shadow: 0px 8px 15px 0px rgba(1, 179, 157, 0.21);
  border-radius: 25px;
}
.addUser-div .btn1,
.selectUser-div .btn1 {
  width: 160px;
  height: 50px;
  background: #ffffff;
  /* box-shadow: 0px 8px 15px 0px rgba(1, 179, 157, 0.21); */
  border-radius: 25px;
}
.btn1 .text {
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
}

.btn .text {
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
}
.zsureBtn {
  /* margin-right: 20px;
  margin-top: 20px; */
  position: absolute;
  bottom: -60px;
  left: 0;
  width: 740px;
  height: 80px;
  padding: 0 30px;
  box-shadow: 0px 1px 0px 0px #E6E6E6;
  border-radius: 0px 0px 30px 30px;
  border-top: 1px solid #E6E6E6;
}

.addUser-div .w-18 {
  width: 90%;
  background: #F4F6F7;
  border-radius: 4px;
}

.selectUser-div {
  background: #fff;
  max-height:  420px;
  min-height:  420px;
  margin: 0 auto;
  border-radius: 30px;
  padding: 20px;
  overflow-y:auto;
}
.selectUser-div1 {
  background: #fff;
  border-radius: 30px;

}
.selectUser-box {
  /* position: relative; */
   max-height:  550px;
  min-height:  550px;
  margin: 0 auto;
  border-radius: 30px;
  padding: 20px;
  overflow-y:auto;
  margin-bottom: 60px;
}
.searchInput ::v-deep() .el-input__inner {
  border-radius: 20px;
  /* height: 50px;
  line-height: 50px; */
  background: #F4F6F7;
  border: none;
}


.w-18 ::v-deep .el-input__inner {
  background-color: #F4F6F7;
  border: none;
}
.center-form ::v-deep .el-form-item__content .el-form-item__error {
  color: #F15C1A;
}
.selectUser-div .selectUser-box,
.test-div .test-box {
  /* width: 90%; */
}
.selectUser-div .userList-div,
.test-div .testList-div {
  width: 100%;
}
.userList-div {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.selectUser-div .active {
  border: 1px solid #1B7DB3 !important;
}

.selectUser-div .item-div:hover {
  border: 1px solid #1B7DB3 !important;
}
/* .selectUser-div .item-div1:hover {
  border: 1px solid #1B7DB3 !important;
} */
.selectUser-div .item-div {
  width: 45%;
  /* margin-right: 2%; */
  margin-bottom: 12px;
  background: #F1F6F9;
  border-radius: 10px;
  cursor: pointer;
  align-items: flex-start !important;
  padding: 17px 16px;
  position: relative;
} 
.item-div1 {
  /* width: 43%; */
  /* height: 140px; */
  /* margin-right: 2%; */
  margin-bottom: 20px;
  background: #FFF9F0;
  border-radius: 30px;
  cursor: pointer;
  padding: 20px 30px;
  /* position: relative; */
}
/* .selectUser-div .item-div1:nth-child(3n) {
  margin-right: 0;
} */
/* .selectUser-div .item-div:nth-child(3n) {
  margin-right: 0;
} */

.selectUser-div .userName {
  width: 100%;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: bold;
}

.selectUser-div .item-div .addBtn {
  width: 100%;
  text-align: center;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #009583;
}

.selectUser-div .userInfo {
  font-size: 16px;
  color: #333333;
}

.selectUser-div .topDel-div {
  position: absolute;
  top: 10px;
  right: 0px;
  font-size: 12px;
  color: #333333;
  cursor: pointer;
  background: #D6E8F2;
  border-radius: 12px 0px 0px 12px;
  padding: 5px 10px;
  padding-left: 15px;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-button {
  display: none;
}
::-webkit-scrollbar-thumb {
  background: #c2c2c2;
  border-radius: 3px;
}
.startBoxleft {
  position: relative;
  width: 800px;
  min-height: 550px;
  max-height: 550px;
  background: #ffffff;
  border-radius: 30px;
  padding: 30px 20px;
  margin: auto;
  overflow-y: auto;
}
.startBoxleftTop {
  height: 500px;
  overflow: hidden;
  overflow-y: auto;
}
/*滚动条样式*/
.startBoxleftTop::-webkit-scrollbar {
  width: 4px;
}
.startBoxleftTop::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
.startBoxleftTop::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
}
.startBoxleftBot {
  /* overflow-x:scroll; */
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding-bottom: 15px;
  border-top: 1px solid #e6e6e6;
  position: relative;
}
.startBoxleftBotn {
  margin-top: 12px;
  text-align: right;
  margin-right: 30px;
}
.startBoxright {
  margin-left: 5%;
  width: 30%;
  height: 720px;
  padding: 30px;
  background: #ffffff;
  border-radius: 20px;
  position: relative;
}
.surebtn {
  background: linear-gradient(180deg, #ffb163, #ee9e51);
  font-size: 16px;
  color: #ffffff;
  padding: 17rpx 0;
  width: 100%;
  text-align: center;
}
.wrapDiv {
  width: calc((100% - 3 * 13px) / 4); /* 4个标签 + 3条间隙均分 */
  /* margin-top: 10px; */
}
.goodTagCheck {
  text-align: center;
  background: #FFF9F2;
  border-radius: 4px;
  font-size: 18px;
  color: #E07712;
  cursor: pointer;
  border: 1px solid #FFB066;
  /* width: 180px; */
  width: 100%;
  text-align: center;
  height: 44px;
  line-height: 44px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* margin-right: 13px; */
   padding: 0 10px;
    box-sizing: border-box;   /* 关键 */
   /* width: 25%; */
}
.goodTag {
  font-size: 18px;
  background: #F1F1F1;
  color: #333333;
  border-radius: 4px;
  cursor: pointer;
  /* width: 180px; */
   width: 100%;
  height: 44px;
  text-align: center;
  line-height: 44px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
   /* margin-right: 13px; */
   padding: 0 10px;
   box-sizing: border-box;   /* 关键 */
  /* width: 25%; */
}
/* 症状 */
.textdetail {
  padding: 15px;
  /* background-color: #f2f2f2; */
  border-radius: 12px;
  max-height: 400px;
  min-height: 200px;
  overflow-y: auto;
}
.viptable {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  overflow-x: auto;
}
.viptableY {
  width: 100%;
  height: 150px;
  overflow: hidden;
  overflow-y: auto;
}
.endbox {
  margin-top: -50px;
  padding: 15px;
  background: #ffffff;
  box-shadow: 0px 6px 0px 0px #f3d6bc;
  border-radius: 10px;
  border: 1px solid #f3d6bc;
}
.endboxright {
  margin-top: 15px;
  padding: 10px 15px;
  background: #ffffff;
  box-shadow: 0px 6px 0px 0px #f3d6bc;
  border-radius: 10px;
  border: 1px solid #f3d6bc;
  cursor: pointer;
}
.ring {
  width: 12px;
  height: 12px;
  border: 3px solid #cf7f31;
  box-shadow: 0px 2px 3px 0px rgba(202, 127, 55, 0.3);
  border-radius: 50%;
}
.endbox1 {
  margin-top: 20px;
  padding: 15px;
  background: #ffffff;
  box-shadow: 0px 4px 8px 0px rgba(214, 214, 214, 0.3);
  border-radius: 10px;
  position: relative;
  border: 1px solid #ffe5cb;
}
.ring1 {
  width: 6px;
  height: 6px;
  background: #df7d1f;
  border-radius: 50%;
}
.ring2 {
  width: 6px;
  height: 6px;
  background: #3bc8d9;
  border-radius: 50%;
}
.ring3 {
  width: 6px;
  height: 6px;
  background: #68caa9;
  border-radius: 50%;
}
.boxtag2 {
  position: absolute;
  top: 0;
  right: 0;
  padding: 7px;
  color: #ffffff;
  border-radius: 10px 0px 10px 0px;
  background-color: #3bc8d9;
  font-size: 24rpx;
}
.boxtag3 {
  position: absolute;
  top: 0;
  right: 0;
  padding: 7px;
  color: #ffffff;
  border-radius: 10px 0px 10px 0px;
  background: #68caa9;
  font-size: 12px;
}
.boxtag1 {
  position: absolute;
  top: 0;
  right: 0;
  padding: 7px;
  color: #ffffff;
  border-radius: 10px 0px 10px 0px;
  background-color: #f6a11f;
  font-size: 12px;
}
.flexlr {
  display: flex;
  justify-content: space-between;
}
.resultimg {
  width: 100%;
  height: 200px;
  background-size: cover;
  background-image: url("../../assets/img/zdrugConsult/resultback.png");
}
.rightBottom {
  padding: 10px 25px;
  background: #f0f2f2;
  border-radius: 25px;
  font-size: 13px;
  color: #999999;
  text-align: center;
}
.rightBottomBox {
  border-top: 1px solid #e6e6e6;
  padding: 20px;
  position: absolute;
  bottom: 0;
  left: 0;
  background: #fff;
}
.radioBox {
  margin: 10px 0;
  font-size: 18px;
}
.imgTag {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  margin-left: 10px;
  border-radius: 8px;
}
.imgTagCheck {
  background-color: #feaf62;
  /* opacity: 0.5; */
  padding: 5px;
}
.textCheck {
  color: #df7d1f;
}
.textBox {
  display: flex;
  flex-wrap: wrap;
}
.symptomsText {
  font-size: 15px;
  color: #666666;
  margin: 8px 0;
  padding-left: 22px;
  /* overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical; */
}
.itembox {
  width: 50%;
}
.nodataimg {
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.hide-tooltip {
  max-width: 400px;
  /* visibility: hidden; */
}
.newChecked {
  color: #df7d1f;
}
.drugTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-items: center;


}
.drugTitle1 {
  font-size: 28px;
  color: #333333;
}
.zdrugInputclass {
  width: 800px;
  margin: auto;
  padding: 10px 20px;
  font-size: 18px;
  color: #666666;
  background: #FFFFFF;
  border-radius: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 20px;

}
::v-deep .el-dialog {
  /* width: 48% !important; */
  margin-top: 20vh !important;
}
.dialogTitle {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  color: #F15C1A;
}
.startBtn {
  color: #ffffff;
  padding: 10px 0;
  text-align: center;
  width: 500px;
  font-size: 24px;
  cursor: pointer;
  background: linear-gradient(270deg, #E89948, #F2B676);
  border-radius: 10px;
  margin: auto;
  margin-top:30px;
  margin-bottom:10px
}
.startBtn2 {
  color: #ffffff;
  padding: 10px 0;
  text-align: center;
  width: 500px;
  font-size: 16px;
  cursor: pointer;
  background: linear-gradient(270deg, #EEAB66, #EFC279);
  border-radius: 25px;
  margin: auto;
  margin-top:30px;
  margin-bottom:30px
}
.startBtn1 {
  color: #ffffff;
  padding: 5px 0;
  text-align: center;
  width: 450px;
  font-size: 16px;
  color: #FFFFFF;
  cursor: pointer;
  background: linear-gradient(270deg, #EEAB66, #EFC279);
  border-radius: 25px;
  /* margin-right:10% */
  position: absolute;
  bottom: -60px;
  left: 50%;
  transform: translateX(-60%);
}
.sexBox {
  background: rgba(250,230,220,0.36);
  border-radius: 2px;
  border: 1px solid #FF6846;
  font-size: 12px;
  color: #FF6846;
  padding:1px 3px;
  line-height: 1.0;
  /* display: inline-block; */
}

</style>
<style>
.personal-center {
  display: none;
}
</style>
